module.exports = __webpack_public_path__ + "static/media/green-tick.c87cc630.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/green-tick.svg
// module id = 1617
// module chunks = 1